import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export type MFAStatus = "loading" | "not_enrolled" | "needs_verification" | "verified";

export function useAdminMFA() {
  const [status, setStatus] = useState<MFAStatus>("loading");
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    checkMFAStatus();
  }, []);

  const checkMFAStatus = async () => {
    try {
      // Check if user has MFA enrolled
      const { data: factors, error: factorsError } = await supabase.auth.mfa.listFactors();
      
      if (factorsError) {
        console.error("Error checking MFA factors:", factorsError);
        setStatus("not_enrolled");
        return;
      }

      const totpFactor = factors?.totp?.find(f => f.status === 'verified');
      
      if (!totpFactor) {
        setStatus("not_enrolled");
        return;
      }

      // Check current AAL level
      const { data: aalData, error: aalError } = await supabase.auth.mfa.getAuthenticatorAssuranceLevel();
      
      if (aalError) {
        console.error("Error checking AAL:", aalError);
        setStatus("needs_verification");
        return;
      }

      if (aalData.currentLevel === 'aal2') {
        setStatus("verified");
      } else {
        setStatus("needs_verification");
      }
    } catch (error) {
      console.error("Error in MFA check:", error);
      setStatus("not_enrolled");
    } finally {
      setIsChecking(false);
    }
  };

  const refreshStatus = () => {
    setIsChecking(true);
    checkMFAStatus();
  };

  return { status, isChecking, refreshStatus };
}
